import axios from "axios";
import {
  accessTokenCookieName,
  baseUrl,
  refreshTokenCookieName,
} from "../../common/config";
import { loginCookies } from "../utils/auth";

const REFRESH_TOKEN_ENDPOINT = `${baseUrl}/api/auth/participant/refresh-token`;

export const refreshToken = async () => {
  try {
    const response = await axios.post(REFRESH_TOKEN_ENDPOINT, {
      accessToken: loginCookies.get(accessTokenCookieName),
      refreshToken: loginCookies.get(refreshTokenCookieName),
    });
    const { data } = response.data;
    loginCookies.set(accessTokenCookieName, data.accessToken);
    loginCookies.set(refreshTokenCookieName, data.refreshToken);
  } catch (e) {
    loginCookies.remove(accessTokenCookieName);
    loginCookies.remove(refreshTokenCookieName);
    window.location.replace("/"); //use history when http is changed to a hook
  }
};
